import Image from "next/image";
import { FormattedMessage, useIntl } from "react-intl";
import { ReactNode } from "react";
import { addBasePathToStrapiMedia, formatStrapiEntity } from "@/utils/strapi";
import { SpotlightProps } from "@/utils/formatCategoryPage";
import styles from "./Spotlight.module.scss";

export const Spotlight = ({
  backgroundTitle,
  image,
  learnerMinimumDrivingLicenseYear,
  minimumDrivingLicenseYear,
  title,
}: SpotlightProps) => {
  const strapiImage = formatStrapiEntity(image);
  const intl = useIntl();

  return (
    <div className={styles.spotlight}>
      <div className={styles.titles}>
        <h2 className={styles.title}>{title}</h2>
        <h3 className={styles.backgroundTitle}>{backgroundTitle}</h3>
      </div>
      <div className={styles.imageCard}>
        <div className={styles.imageContainer}>
          <Image
            src={addBasePathToStrapiMedia(strapiImage)}
            objectFit="contain"
            objectPosition="center"
            alt={strapiImage.alternativeText ?? ""}
            layout="fill"
          />
        </div>
        {minimumDrivingLicenseYear && learnerMinimumDrivingLicenseYear && (
          <div className={styles.informationsCard}>
            <div className={styles.license}>
              <FormattedMessage
                id="minimumDrivingLicenseYearLabel"
                values={{
                  b: (chunks: ReactNode[]) => (
                    <span className={styles.boldBlue}>{chunks}</span>
                  ),
                  number: (chunks: ReactNode[]) => (
                    <span className={styles.number}>{chunks}</span>
                  ),
                  minimumYear: minimumDrivingLicenseYear,
                }}
              />
            </div>
            <div className={styles.separator}>
              {intl.formatMessage({ id: "minimumYearSeparator" })}
            </div>
            <div className={styles.licenseJunior}>
              <FormattedMessage
                id="learnerMinimumDrivingLicenseYearLabel"
                values={{
                  b: (chunks: ReactNode[]) => (
                    <span className={styles.boldBlue}>{chunks}</span>
                  ),
                  number: (chunks: ReactNode[]) => (
                    <span className={styles.number}>{chunks}</span>
                  ),
                  minimumYear: learnerMinimumDrivingLicenseYear,
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
